import NZIFFLogo from "./logos/nziff";
import BeteveLogo from "./logos/beteve";
import BlueprintLogo from "./logos/blueprint";
import ClassificationLogo from "./logos/classification";
import SwimmLogo from "./logos/swimm";
import GoldfishLogo from "./logos/goldfish";
import OtoxoLogo from "./logos/otoxo";
import SpanaLogo from "./logos/spana";

export const LogoData = [
  {
    url: "https://www.nziff.co.nz/2025/nau-mai-haere-mai/",
    component: <NZIFFLogo />,
  },

  {
    url: "https://beteve.cat/",
    component: <BeteveLogo />,
  },

  {
    url: "https://www.weswwim.com/",
    component: <SwimmLogo />,
  },

  {
    url: "https://www.otoxoproductions.com/",
    component: <OtoxoLogo />,
  },

  {
    url: "https://www.classificationoffice.govt.nz/",
    component: <ClassificationLogo />,
  },
  {
    url: "https://www.blueprintfilm.co.uk/",
    component: <BlueprintLogo />,
  },
  {
    url: "https://spana.org/",
    component: <SpanaLogo />,
  },
  {
    url: "https://www.goldfishcreative.co.nz/",
    component: <GoldfishLogo />,
  },
];
